// extracted by mini-css-extract-plugin
export default {"Container":"IFTabs_Container__GaEAb","IFTabTitle":"IFTabs_IFTabTitle__7akB6","CountDiv":"IFTabs_CountDiv__z+A4G"};